export enum Type {
  primary = 'primary',
  error = 'error',
  success = 'success',
}

export type Props = {
  type?: Type;
};
